export const preventNegativeNumberKeyDown = (event) => {
    if (!(event.key.match(/^[0-9\b]+$/) ||
        event.key === 'Backspace' ||
        event.key === 'Delete' ||
        event.key === 'Tab' ||
        event.key === 'Enter' ||
        event.key === 'Escape' ||
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowRight' ||
        event.key === 'Home' ||
        event.key === 'End')) {
        event.preventDefault();
    }
};
